import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ProtectedRoute from "../common/ProtectedRoute";
import AuthRestaurante from "../paginas/AuthRestaurante";
import { getMerchantHomePath } from "../../services/local/merchantEntryNavigation";

function MerchantDestination() {
  const { canAccessModule } = useAuth();
  return <Navigate to={getMerchantHomePath(canAccessModule)} replace />;
}

export default function WePedidosMerchantEntry() {
  const { session, loadingAuth, isCreatorMode } = useAuth();

  if (!session && !loadingAuth && !isCreatorMode) {
    return <AuthRestaurante merchantEntry />;
  }

  return (
    <ProtectedRoute>
      <MerchantDestination />
    </ProtectedRoute>
  );
}
